import { cmsNotificationShownSrc83Evid6 } from '@wix/bi-logger-wix-code-data/v2'
import { NotificationType } from '@wix/editor-platform-sdk-types'
import { type AppApi } from '@wix/wix-data-client-common'
import {
  BI_CM_EDITOR_ENV,
  type I18n,
  type Logger,
} from '@wix/wix-data-client-common-standalone'
import { PermissionRole, type Permissions } from '@wix/wix-data-schema-types'

export const notifyIfInsufficientEditingPermissionsForMembers = async ({
  appApi,
  builderType,
  collectionId,
  collectionName,
  i18n,
  logger,
  origin,
  pageType,
  permissions,
}: {
  appApi: AppApi
  builderType: 'studio'
  collectionId: string
  collectionName: string
  i18n: I18n
  logger: Logger
  origin: 'edit_page'
  pageType: 'edit_page'
  permissions: Permissions
}) => {
  const areEditingPermissionsForMembersInsufficient = (
    ['read', 'remove', 'update'] satisfies (keyof Permissions)[]
  ).some(
    operation =>
      permissions[operation] === PermissionRole.admin ||
      permissions[operation] === PermissionRole.siteMemberAuthor,
  )
  if (areEditingPermissionsForMembersInsufficient) {
    const message = i18n.t(
      'insufficientEditingPermissionsForMembersNotification.title',
    )
    const notificationPromise = appApi.showToastNotification(
      {
        message,
        type: NotificationType.Info,
        linkText: i18n.t(
          'insufficientEditingPermissionsForMembersNotification.action',
        ),
      },
      () =>
        appApi.openCreateCollectionPanel({
          origin,
          collectionId,
          initialScreen: 'permissions',
          features: {
            shouldInformAboutInsufficientEditingPermissionsForMembers: true,
          },
        }),
    )

    logger.bi(
      cmsNotificationShownSrc83Evid6({
        builder_type: builderType,
        collection_id: collectionId,
        collection_name: collectionName,
        environment: BI_CM_EDITOR_ENV,
        notificationText: message,
        notification_type: 'insufficient_editing_permissions_for_members',
        page_type: pageType,
      }),
    )

    await notificationPromise
  }
}
